import { Platform, View } from 'react-native';
import React, { Suspense, memo, lazy } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';

const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);

const KnowledgeMenu = ({ navigation }) => {
  const { t } = useTranslation();
  return (
    <DefaultScreen style={{ paddingLeft: 2, paddingRight: 3 }}>
      <XStack flexWrap='wrap' gap={20} columnGap={20} style={{ gap: 5, marginBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard pressFunction={() => {
          navigation.navigate('InternalKnowledge')
        }} subtitle={`${t('knowledgeInternalKnowledge') || 'Access your internal knowledge base'}`} cardTitle={`${t('knowledgeInternalKnowledge') || 'Internal Knowledge'}`}>
          <LazyLottieView source={require('@assets/animations/file-documents.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        {/* <MenuIconCard pressFunction={() => {
          navigation.navigate('ExternalKnowledge')
        }} subtitle={`${t('knowledgeExternalKnowledge') || 'Access external knowledge sources'}`} cardTitle={`${t('knowledgeExternalKnowledge') || 'External Knowledge'}`}>
          <LazyLottieView source={require('@assets/animations/wired-flat-27-globe.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard> */}
        {
          Platform.OS === 'web' && (
            <MenuIconCard pressFunction={() => navigation.navigate('ChatBot')} subtitle={`${t('ChatBot') || 'Interact with AI assistant'}`} cardTitle={`${t('ChatBot') || 'ChatBot'}`}>
              <LazyLottieView source={require('@assets/animations/robo-anim.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
            </MenuIconCard>
          )
        }
        <MenuIconCard pressFunction={() => navigation.navigate('JournalEntry')} subtitle={`${t('JournalEntrySub') || 'Create and manage journal entries'}`} cardTitle={`${t('JournalEntry') || 'Journal Entry'}`}>
          <LazyLottieView source={require('@assets/animations/42404-add-document.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('UserUploadedDocuments')} subtitle={`${t('UserUploadedDocumentsSub') || 'View your uploaded documents'}`} cardTitle={`${t('UserUploadedDocuments') || 'Uploaded Documents'}`}>
          <LazyLottieView source={require('@assets/animations/114389-upload.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
      </XStack>
    </DefaultScreen >
  )
}
export default memo(KnowledgeMenu);

